export function isLeafletMapUsable(map) {
  if (!map) return false;
  if (!map._loaded) return false;
  if (!map._mapPane) return false;

  const container = typeof map.getContainer === 'function' ? map.getContainer() : null;
  if (!container) return false;
  if (!container.isConnected) return false;

  return true;
}

// Stops any ongoing animations or movements on a Leaflet map instance (used before calling functions that manipulate the map view)
export function stopLeafletMap(map) {
  if (!map || typeof map.stop !== 'function' || !isLeafletMapUsable(map)) return;

  try {
    map.stop();
  } catch (error) {
    console.error('Failed to stop Leaflet map', error);
  }
}

// Normalizes various formats of latitude and longitude inputs into a consistent { lat, lng } object format for Leaflet maps
export const normalizeLatLng = (latLng) => {
  if (!latLng) return null;

  // Handles array formatted latitude and longitude, e.g. [lat, lng] and converts them to { lat, lng } format
  if (Array.isArray(latLng) && latLng.length === 2) {
    const [lat, lng] = latLng;
    const latNum = Number(lat);
    const lngNum = Number(lng);
    return Number.isFinite(latNum) && Number.isFinite(lngNum) ? { lat: latNum, lng: lngNum } : null;
  }

  const lat = Number(latLng.lat ?? latLng.latitude);
  const lng = Number(latLng.lng ?? latLng.longitude);

  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

// Calculates the center point of a polygon given an array of its coordinates (handles both [lat, lng] and { lat, lng} formats)
export const calculatePolygonCentroid = (coordinates) => {
  if (!Array.isArray(coordinates) || coordinates.length === 0) return null;

  let latTotal = 0;
  let lngTotal = 0;
  let validCoordsCount = 0;

  coordinates.forEach((coord) => {
    const normalizedCoordinate = normalizeLatLng(coord);
    if (!normalizedCoordinate) return;

    latTotal += normalizedCoordinate.lat;
    lngTotal += normalizedCoordinate.lng;
    validCoordsCount += 1;
  })

  if (validCoordsCount === 0) return null;

  return {
    lat: latTotal / validCoordsCount, // Average latitude of valid coordinates
    lng: lngTotal / validCoordsCount, // Average longitude of valid coordinates
  }
};
